export default __webpack_public_path__ + "images/0x09ef821c35b4577f856ca416377bd2dddbd3d0c9.png";